import { Platform, View } from 'react-native';
import {
  Text,
  Button,
  List,
  IconButton,
  ActivityIndicator,
} from 'react-native-paper';
import { useAppTheme } from '../theme';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { useNavigation } from '@react-navigation/native';
import axios from 'axios';
import {
  setSelectedBusiness,
  setWebModalShown,
} from '../redux/businessListSlice';
import { useState } from 'react';
import { RootStackParamList } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
interface Props {
  webMap?: google.maps.Map | null;
}

export default function DetailsView({ webMap }: Props) {
  const theme = useAppTheme();
  const dispatch = useAppDispatch();
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const { selectedBusiness } = useAppSelector((state) => state.businessList);
  const [placeApiData, setPlaceApiData] =
    useState<google.maps.places.PlaceResult | null>(null);
  const [loading, setLoading] = useState(false);
  const myKey = 'AIzaSyBm3BPU1ZLd8ateJTylWDYt29uAxQHtAAI';

  async function getPlace() {
    if (!placeApiData) {
      setLoading(true);

      if (webMap) {
        const placesService = new google.maps.places.PlacesService(webMap);
        placesService.getDetails(
          {
            placeId: selectedBusiness?.placeId ?? '',
            fields: [
              'formatted_address',
              'opening_hours',
              'formatted_phone_number',
              'website',
            ],
          },
          (place, status) => {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
              setPlaceApiData(place);
            }
          }
        );
      } else {
        const value = await axios.get(
          `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedBusiness?.placeId}&fields=formatted_address%2Copening_hours/weekday_text%2Cformatted_phone_number%2Cwebsite&key=${myKey}`
        );

        if (value.data.status == 'OK') {
          setPlaceApiData(value.data.result);
        } else {
          console.log(value.data.error_message);
        }
      }

      setLoading(false);
    }
  }

  if (!selectedBusiness) {
    return <></>;
  }

  function editButtonPress() {
    if (Platform.OS === 'web') {
      dispatch(setWebModalShown('Edit_Business'));
    } else {
      navigation.navigate('Edit');
    }
  }

  return (
    <>
      <IconButton
        icon="arrow-left"
        onPress={() => dispatch(setSelectedBusiness(null))}
        style={{
          margin: 0,
        }}
      />

      <View
        style={{
          backgroundColor: theme.colors.background,
          paddingHorizontal: 25,
        }}
      >
        <View>
          {/* <Text variant="titleLarge">Business Information</Text> */}
          <Text style={{ marginBottom: 6, fontSize: 24, fontWeight: 'bold' }}>
            {selectedBusiness.name}
          </Text>
          <Text variant="bodyMedium">{selectedBusiness.address}</Text>
          <Text variant="bodyMedium" style={{ marginBottom: 6 }}>
            Business ID: {selectedBusiness.id}
          </Text>
          <List.Section>
            <List.Accordion title="Business Information" onPress={getPlace}>
              {loading ? (
                <ActivityIndicator style={{ margin: 10 }} />
              ) : (
                <>
                  <Text>
                    Phone Number: {placeApiData?.formatted_phone_number}
                  </Text>
                  <Text>Website: {placeApiData?.website} </Text>
                  <Text>
                    Hours of Operation:
                    {placeApiData?.opening_hours?.weekday_text}
                  </Text>
                </>
              )}
            </List.Accordion>
          </List.Section>
          <Button
            mode="text"
            color={theme.colors.primary}
            onPress={editButtonPress}
            style={{ marginLeft: 'auto' }}
          >
            Edit Request
          </Button>
        </View>
      </View>
    </>
  );
}
